import { render, staticRenderFns } from "./school-detail.vue?vue&type=template&id=3b205bf5&scoped=true"
import script from "./school-detail.vue?vue&type=script&lang=js"
export * from "./school-detail.vue?vue&type=script&lang=js"
import style0 from "./school-detail.vue?vue&type=style&index=0&id=3b205bf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b205bf5",
  null
  
)

export default component.exports